// Muticolumn Video Hover Play
document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll('[data-video-hover-container]');
  
  containers.forEach(container => {
    const video = container.querySelector("video");
    if (!video) return;

    // Ensure required attributes for autoplay on mobile
    video.muted = true;
    video.playsInline = true;

    if (window.innerWidth <= 768) {
      // Autoplay for mobile
      video.autoplay = true;
      video.load(); // Force reload to apply autoplay attribute
      video.play().catch(err => {
        console.warn("Mobile autoplay failed:", err);
      });
    } else {
      // Hover play for desktop
      container.addEventListener("mouseenter", () => {
        video.currentTime = 0;
        video.play();
      });

      container.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0;
      });
    }
  });
});
